import { Field, FieldProps } from 'formik';
import React from 'react';
import cx from 'classnames';
import style from './input-with-suffix.module.scss';

interface InputWithSuffixProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  suffix?: React.ReactNode;
  onSuffixClick?: () => void;
}

export const InputWithSuffix: React.FC<InputWithSuffixProps> = ({
  suffix,
  onSuffixClick,
  name,
  ...rest
}) => (
  <Field name={name}>
    {({ field }: FieldProps) => (
      <div className={style.inputWithSuffix}>
        <input
          {...field}
          {...rest}
          className={cx(style.inputField, rest.className)}
        />
        {suffix && (
          <span
            className={style.suffix}
            onClick={onSuffixClick}
            tabIndex={0}
            role="button"
          >
            {suffix}
          </span>
        )}
      </div>
    )}
  </Field>
);
